import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { parseISO, format, subDays } from 'date-fns';

import { UnidataTable } from '~/components';
import { dataInRequest } from '~/store/modules/auditoriaParametros/actions';

export default function AuditoriaParametros() {
  const data = useSelector((state) => state.auditoriaParametros);

  const header = useMemo(
    () => [
      {
        id: 'aupa_data_evento',
        label: 'Data Evento',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
      },
      {
        id: 'aupa_login_executante',
        label: 'Login exec.',
        filter: { type: 'text' },
      },
      {
        id: 'perf_descricao',
        label: 'Perfil',
        filter: { type: 'text' },
      },
      {
        id: 'aupa_modulo_str',
        label: 'Módulo',
        filter: { type: 'text' },
      },
      {
        id: 'veic_codigo_pk',
        label: 'Veículo',
        filter: { type: 'text' },
      },
      {
        id: 'aupa_orgao',
        label: 'Órgão',
        filter: { type: 'number' },
      },
      {
        id: 'aupa_unidade',
        label: 'Unidade',
        filter: { type: 'number' },
      },
      {
        id: 'aupa_parametro_str',
        label: 'Parâmetro',
        filter: { type: 'text' },
      },
      {
        id: 'aupa_resumo_processo',
        label: 'Resumo Processo',
        filter: { type: 'text' },
      },
    ],
    []
  );

  const custom = useMemo(
    () => [
      {
        id: 'data_cadastro_ini',
        label: 'Data Evento (inicio)',
        type: 'initialdatetime',
        defaultValue: format(subDays(new Date(), 3), 'dd/MM/yyyy 00:00:00'),
      },
      {
        id: 'data_cadastro_fim',
        label: 'Data Evento (fim)',
        type: 'finaldatetime',
        defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
      },
    ],
    []
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="aupa_codigo ASC"
      title={'Auditoria Parâmetros'}
      header={header}
      custom={custom}
      read={dataInRequest}
      redux={data}
      keys="aupa_codigo"
      detach="aupa_data_evento"
      create={false}
      update={false}
      delete={false}
      view="VW_AUDITORIA_PARAMETROS"
      reportTitle="Auditoria Parâmetros"
    />
  );
}
